<template>
    <div class="bg-white mark_the_exam pb-5 col-md-12 d-flex p-8">
        <div class="col-md-6 p-0">
            <div style="background-color: rgb(245, 245, 245);">
                <div class="row mt-2">
                    <div class="col-md-12 pl-8">
                        <div class="container header_detail d-flex justify-content-between p-0 mt-4">
                            <h6 style="font-weight: bold;">{{ title }}</h6>
                            <span class="  ">
                                <el-button class="m-2" @click="backQuestion" :disabled="idShow == 1">Câu trước</el-button>
                                <el-button class="btn btn-primary m-2" @click="nextQuestion"
                                           :disabled="disableNextQuestion || checkValueDisable(idShow + 1)">Câu sau</el-button>
                            </span>
                        </div>
                        <div class="">
                            <button style="font-size: 12px" class="rounded-xl py-2 px-4 mr-1 mt-1"
                                    v-for="(item, index) in questions" :index="index" :key="index"
                                    :disabled="checkValueDisable(item.question)"
                                    @click="showQuestion(item)"
                                    @mouseover="testHover(item.question)"
                                    :class="{'bg-primary': idShow == item.question, 'bg-secondary': idShow != item.question, 'no-hover': checkHover}"
                            >
                                {{ item.question }}
                            </button>
                        </div>
                        <p class="description mt-4">
                            {{ question }}
                        </p>
                        <div class="mt-4 d-flex flex-wrap flex-gap">
                          <div class="">
                            <h6 style="font-weight: bold;">Câu trả lời của học viên</h6>
                            <video
                                ref="videoPlayer"
                                class="video-js vjs-default-skin rounded"
                                controls
                                preload="auto"
                                width="320" height="240"
                                style="display: block;"
                            ></video>
                          </div>
                          <div class="">
                            <ul style="margin-top: 20px;display: block;" >
                              <li
                                  v-for="(video, index) in playlist"
                                  :key="index"
                                  @click="selectVideo(index)"
                                  :style="{ cursor: 'pointer', margin: '5px 0', color: currentIndex === index ? 'red' : 'black' }"
                              >
                                ▶ {{ video.name }}
                              </li>
                            </ul>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4 pl-4 pr-4">
                    <h6 style="font-weight: bold;">Nội dung trả lời của học viên</h6>
                    <div>
                        <el-input
                            :autosize="{ minRows: 2, maxRows: 4}"
                            type="textarea"
                            v-model="content"
                            placeholder=" Chọn điểm để hiển thị nhận xét tự động"
                            readonly
                        />
                    </div>

                </div>
                <div class="col-md-12 mt-2 mb-2" style="background-color: rgb(245, 245, 245);">
                    <div class="container p-0 mt-4 ">
                        <h6 style="font-weight: bold;" class="pl-2 mb-2">Lịch sử tương tác</h6>
                        <div class="overflow-auto bg-white p-2 rounded " style="height: 200px">
                            <div v-for="(item, index) in histories" :key="index" class="mt-2">
                                <span style="color: #00aff0" class="ml-6 mr-2 ">{{ defileHistory[item.actor] }}: </span><span>{{ item.action }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-10">
                <h6 style="font-weight: bold;">Xem bản ghi hình đầy đủ của học viên:</h6>
                <div class="d-flex">
                    <input type="text" class="form-control" v-model="video_url" disabled>
                    <el-tooltip class="item" effect="dark" content="Top Left prompts info" placement="top-start">
                        <button class="pl-3" @click="copyText">
                            <i class="el-icon-document-copy"></i>
                        </button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="container px-0  mt-2">
            <test-writing v-if="currentTest==TEST_WRITING" :doneTest="doneTest"
                          @change="currentTest=SUGGESTED_COURSE"></test-writing>
            <NewMarkSpeaking v-if="currentTest == TEST_SPEAKING"></NewMarkSpeaking>
            
        </div>

    </div>
</template>

<script>
import TestWriting from "@/view/pages/test-input/components/ComponentMarkTheExam/TestWriting";
import TestSpeaking from "@/view/pages/test-input/components/ComponentMarkTheExam/TestSpeaking";
import {DEFILE_HISTORY, QUESTION, WRITING} from "@/core/option/testInputOption";
import {Cambridge_Mentor_ID} from "@/core/option/typeCenterBill";
import {GET_AI_RESULT, GET_RESULT_EXAM} from "@/core/services/store/test/testInput.module";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-playlist';
import NewMarkSpeaking from "@/view/pages/test-input/components/ComponentMarkTheExam/NewMarkSpeaking.vue";
export default {
    name: "MarkTestExamAi",
    components: {
        TestSpeaking,
        TestWriting,
        NewMarkSpeaking
    },
    props: {
        uuid: {
            type: String,
            default: () => {
                return ''
            }
        },
    },
    data() {
        return {
            currentTest: this.$route.query.typeMark,
            TEST_SPEAKING: 0,
            TEST_WRITING: 1,
            SUGGESTED_COURSE: 2,
            testIELTS: false,
            doneTest: false,
            idSchedule: null,
            centerID: this.$route.query.centerID,
            Cambridge_Mentor_ID: Cambridge_Mentor_ID,
            questions: [],
            title: QUESTION[1].title,
            idShow: 1,
            disableNextQuestion: false,
            question: '',
            video_url: null,
            content: '',
            records: [],
            record_url: '',
            record_url_list_of_question: [],
            playlist: [],
            checkDisable: 0,
            histories: [],
            defileHistory: DEFILE_HISTORY,
            interactionLog: [],
            recordIds: [],
            checkHover: false,
            player: null,
            currentIndex: 0,
        }
    },
    created() {
    },
    mounted() {
        this.getResult();
    },
    computed: {
        activeClass() {
            return this.idShow === this.item.id ? 'bg-primary' : 'bg-secondary';
        }
    },
    methods: {
     async initPlayer() {
        // Khởi tạo player
       if(this.player === null){
         this.player = videojs(this.$refs.videoPlayer, {}, () => {
           console.log('Video.js đã sẵn sàng');
         });
       }
        if(this.record_url_list_of_question.length === 0)return
       this.playlist =  this.record_url_list_of_question.map((record_url,index)=>{
          return {
            name: `Đoạn ${index+1} `,
            sources: [{ src: `${record_url}`, type: 'video/webm' }]
          }
        })
        if(this.playlist.length === 0)return
        // Thiết lập playlist
       await this.player.playlist(this.playlist);
        await this.player.playlist.autoadvance(0); // Tự phát tiếp
       this.currentIndex = 0;

// Phát video đầu tiên
       this.player.playlist.currentItem(0);
       this.player.play();
       console.log(this.playlist)
        await this.player.on('playlistitem', () => {
          this.currentIndex = this.player.playlist.currentItem();
        });
      },
      selectVideo(index) {
        this.currentIndex = index;
        this.player.playlist.currentItem(index);
      },
        async getResultTests() {
            let test_input_schedule_id = this.$route.params.id
            let data = await this.$store.dispatch(GET_RESULT_EXAM, test_input_schedule_id ?? 0);
            if (!data.error) {
                this.idSchedule = data.data.test_input_schedule_id
                let keys = ["speaking", "writing", "listening", "vocabulary", "reading"];
                if (data.data?.vocabulary?.right_answers > 1) {
                    keys = ["speaking", "writing", "listening", "reading"];
                    this.testIELTS = true
                } else {
                    keys = ["speaking", "vocabulary"];
                }
                let count = 0
                let res = keys.forEach((obj) => {
                    if (!data?.data?.hasOwnProperty(obj) || data.data[obj] == null) {
                        return
                    }
                    count++
                })
                this.doneTest = (this.testIELTS && (count == 3 || count == 4)) || (!this.testIELTS && ((count == 1 && data?.data?.speaking == null) || count == 2))
                this.currentTest = (!this.testIELTS && this.currentTest == WRITING && data.data[speaking] != null) ? 2 : this.$route.query.typeMark
                if ((count == 4 && this.testIELTS) || (count == 2 && !this.testIELTS)) {
                    this.currentTest = 2
                }
            }
        },

        showQuestion(item) {
            let id = item.question;
            let records = this.records.filter((d) => d.question == id);
            this.idShow = item.question;
            this.title = item.part_text;
            this.question = item.question_text;
            this.content = records[0] ? records[0].transcript : '';
            this.record_url = records[0] ? records[0].record_url : '';
            this.record_url = records ? records[0].record_url : '';
          console.log(this.record_url)
            this.record_url_list_of_question = this.record_url ? this.record_url.split('#'):[]
            this.initPlayer()
          this.histories = this.interactionLog.filter((d) => d.question == id);
            // this.$nextTick(() => {
            //     if (this.$refs.videoPlayer) {
            //         this.$refs.videoPlayer.load();
            //     }
            // });
            if (this.idShow == 1) {
                this.disableNextQuestion = false;
                return;
            }
            if (this.idShow == Object.values(this.questions).length) {
                this.disableNextQuestion = true;
                return;

            }
        },
        nextQuestion() {
            if (this.idShow == Object.values(this.questions).length) {
                this.disableNextQuestion = true;
                return;
            }

            let index = this.idShow++;

            let records = this.records.filter((d) => d.question == this.idShow);
            this.title = this.questions[this.idShow].part_text;
            this.question = this.questions[this.idShow].question_text;
            this.content = records ? records[0].transcript : '';
            this.record_url = records ? records[0].record_url : '';
            this.histories = this.interactionLog.filter((d) => d.question == this.idShow);
            this.record_url = records ? records[0].record_url : '';
          this.record_url_list_of_question = this.record_url ? this.record_url.split('#'):[]
            // this.$nextTick(() => {
            //     if (this.$refs.videoPlayer) {
            //         this.$refs.videoPlayer.load();
            //     }
            // });
          this.initPlayer()
            if (this.idShow == this.checkDisable) {
                this.disableNextQuestion = true;
                return;
            }
            return index;
        },
        backQuestion() {
            if (this.idShow == Object.values(this.questions).length) {
                this.disableNextQuestion = false;
            }
            this.idShow = this.idShow - 1;
            let index = this.idShow;

            let records = this.records.filter((d) => d.question == index);

            this.title = this.questions[index].part_text;
            this.question = this.questions[index].question_text;
            this.content = records ? records[0].transcript : '';
            this.record_url = records ? records[0].record_url : '';
          this.record_url_list_of_question = this.record_url ? this.record_url.split('#'):[]
            this.histories = this.interactionLog.filter((d) => d.question == index);

            // this.$nextTick(() => {
            //     if (this.$refs.videoPlayer) {
            //         this.$refs.videoPlayer.load();
            //     }
            // });
            this.initPlayer()
            if (this.idShow == 1) {
                this.disableNextQuestion = false;
                return;
            }
            return index;
        },
        getResult() {
            this.$store.dispatch(GET_AI_RESULT, {token: this.uuid}).then((res) => {
                this.questions = res.data.questions;
                this.records = res.data.records;
                this.recordIds = this.records.map((d) => d.question)
                this.idShow = this.recordIds[0];
                let index = this.idShow - 1;
                this.interactionLog = res.data.interactionLog;
                this.histories = res.data.interactionLog.filter((d) => d.question == 1);
                this.title = res.data.questions[index].part_text;
                this.question = res.data.questions[index].question_text;
                this.record_url = res.data.records[index].record_url;
                this.record_url_list_of_question = this.record_url ? this.record_url.split('#'):[]
                this.video_url = res.data.video_url;
                this.content = res.data.records[index].transcript
                this.checkDisable = res.data.records.length;
                // this.$nextTick(() => {
                //     if (this.$refs.videoPlayer) {
                //         this.$refs.videoPlayer.load();
                //     }
                // });
              this.initPlayer()
            })
        },
        checkValueDisable(id)
        {
            return this.recordIds.indexOf(id) == -1;
        },
        copyText() {
            navigator.clipboard.writeText(this.video_url);
            this.$notify({
                title: 'Thành công',
                message: 'Copy thành công !',
                type: 'success'
            });
        },
        testHover(id)
        {
            this.checkHover = this.checkValueDisable(id)
        }
    }
}
</script>

<style scoped>
.mark_the_exam {
    height: 100%;
}

.mark_the_exam {
    box-sizing: border-box;
}

.no-hover:hover {
    background-color: #E4E6EF !important;
    color: inherit;
    cursor: default;
}



    .flex-gap>* {
        margin-right: 8px;
        margin-bottom: 8px;
    }

</style>